
/**
 * Created by nijin on 5/6/17.
 */
import {Component, OnInit, EventEmitter, Output} from '@angular/core';
import {ApiKeyService} from '../../api-key.service';
import {NotificationBarService} from '../../../core/notify/notification.service';
import {NotificationType} from '../../../core/notify';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'nuc-no-key',
  template: `
    <div class="introAPIkey">
	       <div class="clearfix">
		       <img src="/assets/images/api_key_intro.png" id="key-illustration">
		       <p>{{'API_KEY.CONTENT' | translate}}</p>
	       </div>
    </div>
  <div class="emptyAPIkey">
	   <p>{{'API_KEY.NO_KEY' | translate}}<span>{{'API_KEY.API_KEY' | translate}}</span> 
	    {{'API_KEY.WITH_ACC' | translate}}
	    </p>
	   <button class="btn btn-primary" (click)= "generate()" [disabled]="isLoading" id="key-generate">
	     <span *ngIf="!isLoading"> {{'API_KEY.NEW_API_KEY' | translate}}</span> 
	     <span *ngIf="isLoading"> <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> 
	     {{'API_KEY.GENERATING' | translate}}</span>
	   </button>
	   <p class="devDocLink">{{'API_KEY.GET_STARTED' | translate}}
	   <a id="key-doc-link" [href]="devDocUrl" target="_blank">{{'API_KEY.DOC' | translate}}</a></p>
</div>
`,
  styleUrls: ['./blank-state.component.scss']
})
export class BlankStateComponent implements OnInit {
  devDocUrl: string;
  isLoading = false;
  @Output() onKeyGenerated: EventEmitter<any> = new  EventEmitter<any>();

  constructor(private apikeyService: ApiKeyService,
              private notifier: NotificationBarService) {
    this.devDocUrl = environment.devDocUrl;
  }

  ngOnInit() {
  }

  generate(): void {
    this.isLoading = true;
    const data = {
      whitelistIps: [
    ]
    };
    this.apikeyService.generateApiKey(data)
      .subscribe((response) => {
        this.notifier.create({type: NotificationType.Success, message: response.status.message});
        this.onKeyGenerated.next(response.data);
        this.isLoading = false;
    }, () => {this.isLoading = false; });
  }

}




// WEBPACK FOOTER //
// ./src/app/accounts/api-key/sub/blank-state.component.ts